.calendar {
	width: fit-content;
	max-width: 100%;

	& .grid {
		border-collapse: separate;
		border-spacing: var(--lp-spacing-200);
	}

	& header {
		display: flex;
		align-items: center;
		margin-bottom: var(--lp-spacing-500);

		& h2 {
			font: var(--lp-text-heading-2-semibold);
			flex: 1;
			text-align: center;
		}
	}

	& th {
		font: var(--lp-text-label-2-medium);
		color: var(--lp-color-text-ui-secondary);
		padding: 0;
		height: var(--lp-size-28);
	}

	& [slot='errorMessage'] {
		color: var(--lp-color-text-feedback-error);
		font: var(--lp-text-body-2-regular);
	}

	& td {
		padding: 0;
	}
}

.cell {
	outline: none;
	border: none;
	width: var(--lp-size-32);
	position: relative;

	&[data-outside-month] {
		display: none;
	}

	&[data-disabled] {
		background-color: transparent;
	}

	&[data-invalid] {
		background-color: var(--lp-color-bg-feedback-error);
		color: var(--lp-color-text-feedback-error);
	}
}

.range {
	& td {
		& [data-selected]:not(:where([data-selection-start], [data-selection-end]))::after {
			background-color: var(--lp-color-bg-interactive-selected);
			position: absolute;
			height: 100%;
			content: '';
			transform: translateZ(-1px);
			/* Width of cell + 2 * border-spacing + 2 * space from border-radius */
			width: calc(var(--lp-size-32) + (2 * var(--lp-spacing-200)) + (2 * var(--lp-size-6)));
		}

		&:first-child {
			& [data-selected]::after {
				width: var(--lp-size-20);
				right: calc(-1 * var(--lp-size-10));
			}
		}

		&:last-child {
			& [data-selected]::after {
				width: var(--lp-size-20);
				left: calc(-1 * var(--lp-size-10));
			}
		}

		&:has(+ td [data-outside-month]),
		&:has([data-outside-month]) + td {
			& [data-selected]::after {
				content: none;
			}
		}
	}

	& .cell {
		&[data-selected] {
			transform-style: preserve-3d;
		}

		&[data-selected]:not(:where([data-selection-start], [data-selection-end])) {
			background-color: var(--lp-color-bg-interactive-selected);
			color: var(--lp-color-text-interactive-selected);
		}
	}
}

.picker {
	display: flex;
	gap: var(--lp-spacing-300);

	&:has([data-orientation='horizontal']) {
		flex-direction: column;
	}

	&:has([data-orientation='vertical']) {
		flex-direction: row;
	}
}

.today {
	fill: var(--lp-color-fill-ui-secondary);
	position: absolute;
	bottom: var(--lp-size-2);
}
